module.exports = __webpack_public_path__ + "media/images/emoticons/memo-2cfbb9119d9114532eb2b2ae2cd8707e.gif";